import React from 'react';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { TargetAudience } from './components/TargetAudience';
import { SystemOverview } from './components/SystemOverview';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { Comparison } from './components/Comparison';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-ballet-50 font-sans text-charcoal selection:bg-ballet-200 selection:text-charcoal" data-id="element-0">
      <Hero data-id="element-1" />
      <Testimonials data-id="element-2" />
      <PainPoints data-id="element-3" />
      <TargetAudience data-id="element-4" />
      <SystemOverview data-id="element-5" />
      <Volumes data-id="element-6" />
      <Bonuses data-id="element-7" />
      <Comparison data-id="element-8" />
      <Pricing data-id="element-9" />
      <Guarantee data-id="element-10" />
      <FAQ data-id="element-11" />
      <Footer data-id="element-12" />
    </div>;
}